<template>
<div class="sidebar-apio">
  <div class="sidebar-apio__logo" :class="{ 'sidebar-apio__logo--dark': isDarkMode }" >
    <img class="sidebar-apio__logo--text" src="img/brand/apio2.png" />
    </div>
  <v-list>
    <v-list-item v-for="item in items" :key="item.title" :to="item.path" class="d-flex flex-column align-start">
      <div class="sidebar-apio__menu-item">
        <div class="sidebar-apio__horizontal-row" v-if="item.title === 'Users'"></div>
        <div class="d-flex">
          <v-list-item-icon v-if="!item.children">
            <apio-icon :name="item.icon" darkModeColour="white" lightModeColour="white"/>
          </v-list-item-icon>

          <v-list-item-title class="white--text" v-text="item.title" v-if="!item.children"></v-list-item-title>
        </div>
      </div>
    </v-list-item>
  </v-list>
  </div>
</template>

<script>
export default {
  name: "Sidebar",
  props: {
    minimize: {
      type: Boolean,
    },
    items: {
      type: Array,
      required: true,
    },
    dark :{
      type: Boolean
    }
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.xs
    },
    isDarkMode() {
      return this.$store.state.mode.darkMode
    },
  }
};
</script>

<style lang="scss" scoped>

::v-deep .v-list-item::after {
  min-height: 0;
}

::v-deep .v-list-group__header {
  padding-left: 0;
}

::v-deep a.v-list-item--active.v-list-item.v-list-item--link.theme--dark {
  background: var(--apio-shade-2);
}

::v-deep a.v-list-item--active.v-list-item.v-list-item--link.theme--light {
  background: var(--apio-shade-1);
}

.sidebar-apio {
  &__logo--text {
    padding: 10px 0 0 7px;
  }
  &__logo {
    height: 60px;
    width: 100%;
    background: var(--apio-shade-1);
    &--dark {
      background: black;
    }
  }
  &__menu-item {
    width: 256px;
  }
  &__horizontal-row {
    height: 1px;
    position: relative;
    left: -16px;
    background-color: var(--apio-shade-3);
    width: calc(100% + 32px);
  }
}
</style>
